export default __webpack_public_path__ + "static/media/03_DAIF_Eco_03_INTEL.7a3b0f58.mp4";